import { createFileRoute, getRouteApi } from '@tanstack/react-router'
import { CustomDomainPage } from '@/components/CustomDomainPage'

export const Route = createFileRoute('/_protected/_site/custom-domain')({
  component: RouteComponent,
})

function RouteComponent() {
  const routeApi = getRouteApi("/_protected/_site")
  const data = routeApi.useLoaderData()

  return <CustomDomainPage site={data} />
}